import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AppBar from './components/AppBar'; // Certifique-se de ajustar o caminho correto
import DedicationForm from './components/DedicationForm';
import Home from './components/Home'; // Certifique-se de ajustar o caminho correto
import About from './components/About';

function App() {
  return (
    <Router>
      <div>
        {/* Barra de Navegação */}
        <AppBar />

        {/* Definindo as Rotas */}
        <Routes>
          <Route path="/" element={<About />} />
          <Route path="/mensagens" element={<Home/>} />
          <Route path="/adicionar" element={<DedicationForm />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
